import { ValidationCheck, ValidationStatus } from '../../../shared/services/turnoGeo/types';

const STYLE: Record<ValidationStatus, { symbol: string; dot: string; label: string }> = {
  ok: { symbol: '✓', dot: 'bg-brand-500 text-white', label: 'Cumple' },
  fail: { symbol: '✕', dot: 'bg-critical text-white', label: 'No cumple' },
  warn: { symbol: '!', dot: 'bg-amber-500 text-white', label: 'Advertencia' },
  na: { symbol: '–', dot: 'bg-ink-200 text-ink-600', label: 'No aplica' },
};

const CONFIDENCE_LABEL: Record<string, string> = { alta: 'confianza alta', media: 'confianza media', baja: 'confianza baja' };

/**
 * Checklist de validaciones de un marcaje: una línea por señal (IP, GPS,
 * horario, foto) con color y el motivo concreto. Verde = cumple, rojo = no
 * cumple, ámbar = advertencia, gris = no aplica.
 */
export function ValidationChecklist({ checks }: { checks: ValidationCheck[] }) {
  if (checks.length === 0) return null;
  return (
    <ul className="space-y-2">
      {checks.map((c) => {
        const style = STYLE[c.status];
        return (
          <li key={c.code} className="flex items-start gap-3 rounded-xl border border-ink-100 bg-surface p-3">
            <span className={['mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-sm font-bold', style.dot].join(' ')} aria-hidden>
              {style.symbol}
            </span>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-ink-800">
                {c.label} <span className="font-normal text-ink-400">· {style.label}{c.confidence ? ` · ${CONFIDENCE_LABEL[c.confidence]}` : ''}</span>
              </p>
              <p className="mt-0.5 break-words text-xs text-ink-500">{c.detail}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
